import React from "react";
import UsedCarsWorkspace from "../components/UsedCarsWorkspace";

export default function UsedCarsBackgroundCheckPage() {
  return <UsedCarsWorkspace stage="background-check" />;
}
